var module = angular.module('components');
module.component('caConfirmButton', {
    templateUrl: 'components/genericcomponents/confirmbutton.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        confirmTitle: '<',
        disabledBy: '<',
        onConfirmPressed: '&'
    },
    controller: ['GenericComponentService', controller]
});


function controller(GenericComponentService)  {
    var vm = this;

    vm.toggleConfirmationVisiblity = toggleConfirmationVisiblity;
    vm.confirm = confirm;

    function toggleConfirmationVisiblity() {
        vm.confirmationVisible = !vm.confirmationVisible;
    }

    function confirm() {
        vm.onConfirmPressed();
    }
}
